import { useQuery } from 'react-query';

import { FORUM_POSTS_KEY, ForumPost, getForumPost } from '@utils/backend-api/forumPosts';

export default function useForumPost(id: number | string) {
  const { data: forumPost, isLoading: isForumPostLoading } = useQuery<ForumPost>(
    [FORUM_POSTS_KEY, id],
    () => getForumPost(id),
    {
      enabled: !!id,
    }
  );

  return { forumPost, isForumPostLoading };
}
